import { render, staticRenderFns } from "./MenuUserAM.vue?vue&type=template&id=ce8bf3ba&scoped=true&"
import script from "./MenuUserAM.vue?vue&type=script&lang=js&"
export * from "./MenuUserAM.vue?vue&type=script&lang=js&"
import style0 from "./MenuUserAM.vue?vue&type=style&index=0&id=ce8bf3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8bf3ba",
  null
  
)

export default component.exports